import React from 'react'
import {Modal} from "antd"
import { useNavigate } from "react-router";
import TablaNotificaciones from '../../../components/TablaNotificaciones/TablaNotificaciones'
const ModalNotificaciones=({isModalVisible,handleCancel}:any)=> {

    const navigate = useNavigate();
const handleRoute =()=>{
    handleCancel()
    navigate("/administrador/centroNotificaciones")

}
    return (
        <div>
            <Modal width={1000}
                   visible={isModalVisible} 
                   onCancel={handleCancel}
                   okText="Ver todo"
                   onOk={handleRoute}
                 
            >

            <TablaNotificaciones/>
            </Modal>
        </div>
    )
}

export default ModalNotificaciones
